import { RouteInterface } from '@/src/common/enums/routes'

export const PointsToStatementCreditRoutes = {
  PointsToStatementCredit: {
    route: '/main/points-to-statement-credit/statement-credit',
    name: 'Points to Statement Credit',
    availableForDeepLinking: false,
  },
  StatementCreditRedemptionConfirmation: {
    route: '/main/points-to-statement-credit/redemption-confirmation',
    name: 'Statement Credit Redemption Confirmation',
    availableForDeepLinking: false,
  },
  StatementCreditSuccessConfirmation: {
    route: '/main/points-to-statement-credit/success-confirmation',
    name: 'Statement Credit Confirmation',
    availableForDeepLinking: false,
  },
} as const satisfies Record<string, RouteInterface>
